import {gsap, ScrollTrigger, SplitText} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class TextAppear {
	static init() {

		if (ScrollTrigger.isTouch === 1) {
			return;
		}

		const items = document.querySelectorAll("[data-text-appear], .title-level-1, .title-level-2, .title-level-3, .title-level-4");

		if (items.length === 0) {}

		this.splitTexts= [];

		items.forEach(elem => {
			// elem.innerHTML = elem.innerHTML.replace(/&nbsp;/g, '___');
			const innerSplit = new SplitText(elem, {
				type: "lines",
				linesClass: "split-inner"
			});

			const outerSplit = new SplitText(elem, {
				type: "lines",
				linesClass: "split-outer"
			});
			this.splitTexts.push(outerSplit);
			this.splitTexts.push(innerSplit);

			elem.classList.add("revealed");
			// elem.innerHTML = elem.innerHTML.replace(/___/g, '&nbsp;');


			const delay = elem.dataset.textAppearDelay ?? 0; // Utilisez l'attribut HTML `data-aos-delay`

			const splitTimeline = gsap.timeline({
				scrollTrigger: {
					trigger: elem,
					start: "top 90%",
				},
			});

			splitTimeline.set(elem, {
				visibility: 'visible'
			});

			splitTimeline.from(innerSplit.lines, {
				delay: parseFloat(delay),
				duration: 1,
				yPercent: 101,
				ease: "power1.ease",
				stagger: 0.15,
				autoAlpha: 0
			});
		});

		GlobalVariables.resizeCallbacks.push(this);
	}

	static resize() {
		this.splitTexts.forEach(item => {
			item.revert();
		});
	}
}
